<template>
    <div>
        <breadCrumb
            :icon="'fa-clipboard-list-check'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_expenses`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4">
                    <expensesFilter
                        ref="expensesFilter"
                        :outlets="outlets"
                        :selectedOutlet="selectedOutlet"
                        @filterOrder="filterOrder"
                        @openProjectionModalDefault="openProjectionModalDefault"
                        @openProjectionModalMonthly="openProjectionModalMonthly"
                        @openExpenditureModal="openExpenditureModal">
                    </expensesFilter>
                </div>

                <expensesProjectionForm
                    ref="expensesProjectionForm"
                    :outlets="outlets"
                    :expenditureType="expenditureTypeGroup"
                    @onModalClose="onExpensesProjectionModalClose">
                </expensesProjectionForm>

                <expensesExpenditureForm
                    ref="expensesExpenditureForm"
                    :outlets="outlets"
                    :expenditureType="expenditureType"
                    @onModalClose="onExpensesExpenditureModalClose">
                </expensesExpenditureForm>

                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content">
                            <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                                <b-spinner label="Loading..."></b-spinner>
                            </div>
                            <expensesCard
                                v-show="selectedTab === 'summary'"
                                ref="expensesCard"
                                :expenditureType="expenditureTypeGroup"
                                @setExportData="setExportData">
                            </expensesCard>
                            <expensesList
                                v-show="selectedTab === 'list'"
                                ref="expensesList" @setExportData="setExportData"
                                @editExpenditure="editExpenditure">
                            </expensesList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ExpensesFilter from './Expenses_Filter'
import ExpensesList from './Expenses_List'
import ExpensesCard from './Expenses_Card'
import ExpensesExpenditureForm from './Expenses_ExpenditureForm'
import ExpensesProjectionForm from './Expenses_ProjectionForm'
import _ from 'lodash';
import moment from 'moment'
import BreadCrumb from './../../Bread_Crumb'
import { handleSessionExpired, setSummaryBoxLabel } from './../../../../assets/js/dashboard/dashboard'
import box, { calculateSalesReportTotal } from './../../../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: 'reportExpenses',
    components: {
        ExpensesFilter, ExpensesCard, ExpensesList, ExpensesExpenditureForm, ExpensesProjectionForm, BreadCrumb
    },
    data() {
        return {
            outlets: [],
            expenditureTypeGroup: [
                { id: 'staff_others', text: 'Staff', form: true, card_projection: true },
                { id: 'util_others', text: 'Utility', form: true, card_projection: true },
                { id: 'marketing_others', text: 'Marketing', form: true, card_projection: true },
                { id: 'rental_others', text: 'Rental', form: true, card_projection: true },
                { id: 'finance_others', text: 'Finance', form: true, card_projection: true },
                { id: 'vendor_others', text: 'Vendor', form: false, card_projection: false },
                { id: 'more_others', text: 'More', form: true, card_projection: true },
                { id: 'total', text: 'Total', form: false, card_projection: true },
            ],
            expenditureType: [],

            filterObj: {},
            selectedOutlet: {},
            selectedTab: {},

            isSpinnerShow: true,

            dataProjection: [],
            dataExpenses: [],
        }
    },
    watch: {
        "$i18n.locale"(val) {
        }
    },
    methods: {
        async getExpenditureType() {
            let $vm = this;
            const url = '/expenditureType'

            await $vm
                .$axios({
                    method: "get",
                    url: url,
                    baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
                    headers: { token: $vm.$session.get("token") },
                })
                .then((response) => {
                    this.expenditureType = response.data.ExpenditureType;
                })
                .catch((err) => {
                    if (err && err.response && err.response.data && err.response.data.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                        return
                    }
                });
        },

        setExportData(item) {
            this.exportObj = item
            this.$refs.expensesFilter.setExportData(item)
        },

        async filterOrder(filterObj) {
            this.filterObj = filterObj
            this.selectedOutlet = filterObj.outlet
            this.selectedTab = filterObj.tab

            this.isSpinnerShow = true
            this.$refs.expensesCard.isLoading = true
            this.$refs.expensesList.isLoading = true
            this.filterOrderImpl()
        },
        async filterOrderImpl() {
            if (this.selectedTab === 'summary') {
                await this.getExpenditureSummary(this.filterObj)
            } else if (this.selectedTab === 'list') {
                await this.getExpenditure(this.filterObj)
            }
            this.isSpinnerShow = false
        },

        async getExpenditureSummary(filterObj) {
            // var dateFilter = moment(filterObj.date.startDate).format('YYYYMMDD')
            // var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            // var voidFilter = "&active=" + (filterObj.voided ? "0" : "1")
            // var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search

            let url = `/outlets/${this.selectedOutlet.id}/acct/expenditure/summary?start=${this.filterObj.date.startDate.getTime() / 1000}&stop=${this.filterObj.date.endDate.getTime() / 1000}`
            this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
                headers: { token: this.$util.getSessionToken() },
            })
                .then((response) => {
                    this.dataExpenditureSummary = response.data
                    this.$refs.expensesCard.setData(this.dataExpenditureSummary, filterObj)
                })
                .catch((err) => {
                    if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                    
                    this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
                })
        },
        async getExpenditure(filterObj) {
            // var dateFilter = moment(filterObj.date.startDate).format('YYYYMMDD')
            // var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            // var voidFilter = "&active=" + (filterObj.voided ? "0" : "1")
            // var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search

            let url = `/outlets/${this.selectedOutlet.id}/acct/expenditure?start=${this.filterObj.date.startDate.getTime() / 1000}&stop=${this.filterObj.date.endDate.getTime() / 1000}`
            this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
                headers: { token: this.$util.getSessionToken() },
            })
                .then((response) => {
                    this.dataExpenditure = response.data
                    this.$refs.expensesList.setData(this.dataExpenditure, filterObj)
                })
                .catch((err) => {
                    if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        openProjectionModalDefault() {
            this.$refs.expensesProjectionForm.show(this.selectedOutlet, false)
        },
        openProjectionModalMonthly() {
            this.$refs.expensesProjectionForm.show(this.selectedOutlet, true)
        },
        onExpensesProjectionModalClose() {
            this.filterOrder(this.filterObj);
        },
        openExpenditureModal() {
            this.$refs.expensesExpenditureForm.show(this.selectedOutlet)
        },
        onExpensesExpenditureModalClose() {
            this.filterOrder(this.filterObj);
        },

        editExpenditure(item) {
            this.$refs.expensesExpenditureForm.show(this.selectedOutlet, item)
        },
    },
    async mounted() {
        var outlets = JSON.parse(this.$store.state.outlets);
        this.outlets.push(...outlets);
        this.selectedOutlet = this.outlets[0]

        this.getExpenditureType()
    },
}
</script>